export default {
  // Account Management
  account: {
    title: 'Carrier Account Management',
    filters: {
      accountName: 'Account Name',
      accountNamePlaceholder: 'Enter account name',
      carrier: 'Carrier/Platform',
      carrierPlaceholder: 'All',
      status: 'Status',
      statusPlaceholder: 'All',
      search: 'Search',
      reset: 'Reset',
      add: 'Add Account'
    },
    columns: {
      accountName: 'Account Name',
      carrier: 'Carrier',
      platformType: 'Platform Type',
      usage: 'Usage',
      loginAccount: 'Login Account',
      status: 'Status',
      maintainer: 'Maintainer',
      updatedAt: 'Updated At',
      actions: 'Actions'
    },
    platformTypes: {
      official: 'Carrier Official',
      thirdParty: 'Third Party',
      internal: 'Internal API'
    },
    usages: {
      query: 'Query',
      booking: 'Booking'
    },
    statusLabels: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    deleteConfirm: 'Are you sure to delete this account?',
    messages: {
      loadSuccess: 'Accounts loaded',
      loadFailed: 'Load accounts failed',
      createSuccess: 'Account created',
      createFailed: 'Create account failed',
      updateSuccess: 'Account updated',
      updateFailed: 'Update account failed',
      deleteSuccess: 'Account deleted',
      toggleSuccess: '{name} {status}'
    },
    // Modal
    modal: {
      create: 'Add Account',
      edit: 'Edit Account',
      company: 'Company',
      companyPlaceholder: 'Default current company',
      carrierPlaceholder: 'Select carrier (optional)',
      usageLabel: 'Usage',
      enabledLabel: 'Enabled',
      enabledText: 'Enabled',
      disabledText: 'Disabled',
      loginAccount: 'Login Account',
      loginAccountRequired: 'Enter login account',
      loginPassword: 'Login Password',
      loginPasswordRequired: 'Enter login password',
      loginPasswordEditPlaceholder: 'Leave blank to keep current',
      remark: 'Remark',
      remarkPlaceholder: 'Enter remark',
      securityTip: 'Currently prototype only. Real passwords must be encrypted and managed by backend.'
    }
  },

  // Daily Rates
  daily: {
    title: 'Daily Rates',
    exportFilename: 'E-commerce Daily Rates',
    exportTitle: 'E-commerce Daily Rates',
    filters: {
      pol: 'POL',
      pod: 'POD',
      containerType: 'Container Type',
      carrier: 'Carrier',
      etd: 'ETD'
    },
    actions: {
      subscriptionConfig: 'Push Config',
      manualRefresh: 'Manual Refresh',
      exportExcel: 'Export Excel',
      search: 'Search',
      reset: 'Reset'
    },
    columns: {
      pol: 'POL',
      pod: 'POD',
      carrier: 'Carrier',
      containerType: 'Container Type',
      basePrice: 'Base Price',
      totalPrice: 'Total Price',
      currency: 'Currency',
      etd: 'ETD',
      eta: 'ETA',
      transitDays: 'Transit (Days)',
      vesselName: 'Vessel',
      voyage: 'Voyage',
      routeCode: 'Route',
      spaceStatus: 'Space',
      isDirect: 'Direct',
      rateUpdatedAt: 'Rate Updated At'
    },
    spaceStatus: {
      available: 'Available',
      soldOut: 'Sold Out',
      unavailable: 'Unavailable'
    },
    directStatus: {
      direct: 'Direct',
      transit: 'Transit'
    },
    messages: {
      loadFailed: 'Load daily rates failed',
      refreshSuccess: 'Refreshed successfully',
      exportSuccess: 'Exported successfully',
      noDataToExport: 'No data to export',
      exportFailed: 'Export failed'
    },
    exportDrawer: {
      title: 'Export Daily Rates',
      subtitle: 'Select the export template to use. The platform provides standard templates, and also supports custom ones.',
      defaultTemplatesTitle: 'Platform Default Templates',
      customTemplatesTitle: 'Custom Templates',
      coreTemplateName: 'Standard Template (Core Fields)',
      coreTemplateDesc: 'POL, POD, Container Type, Carrier, 40GP Price, 40HQ Price, ETD, ETA',
      fullTemplateName: 'Standard Template (Full Fields)',
      fullTemplateDesc: 'Includes core fields + Rate No., Cargo Type, 20GP/45HC/Reefer Price, Direct Flag, Free Detention, Free Demurrage, Validity, etc.',
      usLineTemplateName: 'US Line Special Template',
      usLineTemplateDesc: 'Suitable for US line routes push, including USWC/USEC ports',
      europeLineTemplateName: 'Europe Line Detailed Template',
      europeLineTemplateDesc: 'Full set of fields for Europe line, including transit port info',
      salesBriefTemplateName: 'Sales Brief Template',
      salesBriefTemplateDesc: 'Simplified fields, suitable for sales team quick view',
      fieldsCount: '{count} Fields',
      excelExport: 'Excel Export',
      rateExport: 'E-commerce Rates',
      defaultLabel: 'Default',
      confirmExport: 'Confirm Export',
      messages: {
        exportSuccess: 'Export successful',
        noData: 'No data to export',
        exportFailed: 'Export failed'
      }
    }
  },

  // Subscription
  subscription: {
    title: 'Daily Push Config',
    pushConfig: {
      title: 'Push Configuration (Global)',
      pushTimeTitle: '⏰ Push Time',
      pushTimeEarly: 'Morning Push',
      pushTimeLate: 'Evening Push',
      channelEmail: '📧 Email',
      channelHttp: '🔌 HTTP API',
      channelPage: '👁️ Page View Only',
      emailTitle: 'Email Push',
      emailEnabled: 'Enabled',
      receiveEmails: 'Receiving Emails',
      emailInputPlaceholder: 'Enter email, press enter to add',
      httpTitle: 'HTTP API Push',
      httpEnabled: 'Active',
      httpEndpoint: 'HTTP Endpoint',
      httpSecret: 'Secret Key',
      pageTitle: 'Page View Only',
      pageDesc: 'Daily rates are only kept in the system and can be viewed and exported in "Daily Rates".',
      saveSuccess: 'Push configuration saved',
      saveFailed: 'Save failed'
    },
    templateConfig: {
      title: 'Template Configuration (Global)',
      subtitle: 'Select and drag to sort export field templates used when pushing. The platform provides core fields, and also supports customization.',
      defaultTemplatesTitle: 'Platform Default Templates',
      customFieldsTitle: 'Custom Fields Order & Switch',
      coreTemplateName: 'Standard Template (Core Fields)',
      fullTemplateName: 'Standard Template (All Fields)',
      coreTemplateDesc: 'POL, POD, Container Type, Carrier, Base Price, Total Price, ETD, ETA',
      fullTemplateDesc: 'Includes Core Fields + Route, Vessel, Voyage, Direct, Space, Rate Updated At, etc.',
      fieldsCount: '{count} Fields',
      excelExport: 'Excel Export',
      defaultLabel: 'Default',
      selectedCount: 'Selected {selected} / {total} fields',
      selectAll: 'Select All',
      clearAll: 'Clear',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Template configuration saved',
      saveFailed: 'Save failed',
      fields: {
        scheduleId: 'Schedule ID',
        freightId: 'Freight ID',
        carrierCode: 'Carrier',
        vesselName: 'Vessel',
        voyage: 'Voyage',
        routeCode: 'Route Code',
        polCode: 'POL Code',
        podCode: 'POD Code',
        etd: 'ETD',
        eta: 'ETA',
        transitDays: 'Transit Days',
        isDirect: 'Direct',
        containerType: 'Container Type',
        spaceStatus: 'Space Status',
        basePrice: 'Base Price',
        totalPrice: 'Total Price',
        currency: 'Currency',
        rateUpdatedAt: 'Rate Updated At',
        productDetailId: 'Product Detail ID'
      }
    },
    batchAdd: {
      title: 'Batch Add Config',
      alertContent: 'Automatically combine after multi-selection. Unique key: Tenant + POL + POD.',
      polLabel: 'POL (Multi-select)',
      podLabel: 'POD (Multi-select)',
      containerTypeLabel: 'Container Type (Multi-select)',
      carrierLabel: 'Carrier (Multi-select)',
      polPlaceholder: 'Select POL',
      podPlaceholder: 'Select POD',
      containerTypePlaceholder: 'All container types',
      carrierPlaceholder: 'All carriers',
      batchCreateSuccess: 'Batch created successfully, {count} in total'
    },
    actions: {
      add: 'Add Config',
      batchAdd: 'Batch Add',
      edit: 'Edit Config',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      pushConfig: 'Push Config',
      templateConfig: 'Template Config',
      import: 'Batch Import',
      downloadTemplate: 'Download Import Template',
      parse: 'Parse File',
      parsing: 'Parsing...',
      prevStep: 'Previous',
      nextStep: 'Next',
      confirmImport: 'Confirm Import',
      selectPol: 'Select POL',
      selectPod: 'Select POD'
    },
    filters: {
      pol: 'POL',
      pod: 'POD',
      carrier: 'Carrier'
    },
    columns: {
      pol: 'POL',
      pod: 'POD',
      carrier: 'Carrier',
      containerType: 'Container Type',
      frequency: 'Frequency',
      notifyChannels: 'Notify Channels',
      status: 'Status',
      lastPushTime: 'Last Push',
      actions: 'Actions',
      dateCreated: 'Created At',
      fieldName: 'Field Name',
      isRequired: 'Required',
      description: 'Description'
    },
    labels: {
      all: 'All',
      pol: 'POL',
      pod: 'POD',
      containerTypeSelect: 'Container Type (Multiple)',
      containerTypeAll: 'All Container Types',
      carrierSelect: 'Carrier (Multiple)',
      carrierAll: 'All Carriers',
      deleteConfirm: 'Are you sure to delete?',
      importConfig: 'Batch Import Config',
      stepImport: 'Template & Import',
      stepConfirm: 'Confirm Import',
      importTitle: 'Template & Import Function',
      importDesc: 'Download the standard template to batch import data, and the system will automatically parse and generate push configurations. Supports .xlsx, .xls formats.',
      dragUploadTip: 'Click or drag file here to upload',
      fileFormatLimit: 'Supports .xlsx, .xls, file size no more than 10MB',
      parseSuccess: 'Parsed successfully, identified {count} rows',
      fieldDescTable: 'Template Field Description',
      required: 'Required',
      notRequired: 'Optional',
      totalCount: 'Total Rows',
      creatable: 'Creatable',
      failed: 'Failed',
      errorReason: 'Description/Error Reason'
    },
    tplFields: {
      polDesc: 'Port code, e.g., CNSHA',
      podDesc: 'Port code, e.g., DEHAM',
      carrierDesc: 'Carrier code, e.g., MSC',
      containerTypeDesc: 'e.g., 20GP/40GP/40HQ'
    },
    frequency: {
      daily: 'Daily',
      weekly: 'Weekly',
      realtime: 'Real-time'
    },
    statusLabels: {
      active: 'Active',
      paused: 'Paused'
    },
    notifyChannels: {
      email: 'Email',
      system: 'System Message'
    },
    messages: {
      loadFailed: 'Load subscriptions failed',
      createSuccess: 'Subscription created',
      updateSuccess: 'Subscription updated',
      deleteSuccess: 'Subscription deleted',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Submit failed',
      deleteFailed: 'Delete failed',
      importSuccess: 'Imported successfully!',
      importFailed: 'Import failed',
      polPodRequired: 'Please select POL and POD',
      downloadSuccess: 'Template downloaded successfully',
      downloadFailed: 'Template download failed'
    }
  }
}
